import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const AddFileIcon: React.FC<AddIconProps> = ({ size = 64, color = '#4E4E4E' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4203_75854)">
      <path d="M52.6091 58.654C52.6189 59.9616 51.5494 61.0395 50.2305 61.0438L14.3945 61.1626C13.087 61.1724 12.009 60.103 12.0047 58.784L11.8317 4.99059C11.8219 3.68302 12.8914 2.60508 14.2103 2.60078L35.7468 2.53244C37.0544 2.52264 38.884 3.28451 39.8249 4.20344L50.787 15.0991C51.7111 16.0239 52.4767 17.8524 52.4865 19.1599L52.6204 58.6595L52.6091 58.654Z" fill="white" stroke={color} strokeWidth="0.842105" strokeLinecap="round" stroke-linejoin="round" />
      <path d="M50.7751 15.0935L39.813 4.19785C39.0201 3.40682 37.5524 2.73649 36.316 2.57072L36.3647 16.2388C36.3745 17.5464 37.4469 18.6272 38.7545 18.6174L52.4226 18.5688C52.2447 17.3477 51.568 15.8846 50.7751 15.0935Z" fill="#F1F0F0" stroke={color} strokeWidth="0.842105" strokeLinecap="round" stroke-linejoin="round" />
      <line x1="17.982" y1="23.2553" x2="42.9122" y2="23.2553" stroke={color} strokeWidth="1.11628" strokeLinecap="round" />
      <line x1="17.982" y1="26.977" x2="42.9122" y2="26.977" stroke={color} strokeWidth="1.11628" strokeLinecap="round" />
      <line x1="17.982" y1="30.6977" x2="42.9122" y2="30.6977" stroke={color} strokeWidth="1.11628" strokeLinecap="round" />
      <line x1="17.982" y1="34.4184" x2="37.7029" y2="34.4184" stroke={color} strokeWidth="1.11628" strokeLinecap="round" />
      <line x1="17.982" y1="38.1391" x2="37.7029" y2="38.1391" stroke={color} strokeWidth="1.11628" strokeLinecap="round" />
      <line x1="17.982" y1="41.8608" x2="37.7029" y2="41.8608" stroke={color} strokeWidth="1.11628" strokeLinecap="round" />
      <line x1="17.982" y1="45.5815" x2="37.7029" y2="45.5815" stroke={color} strokeWidth="1.11628" strokeLinecap="round" />
      <line x1="17.982" y1="49.3022" x2="37.7029" y2="49.3022" stroke={color} strokeWidth="1.11628" strokeLinecap="round" />
    </g>
    <path d="M52.251 31.0742C58.2953 31.0742 63.1952 35.9742 63.1953 42.0186C63.1953 48.063 58.2954 52.9629 52.251 52.9629C46.2066 52.9627 41.3066 48.0629 41.3066 42.0186C41.3068 35.9743 46.2067 31.0744 52.251 31.0742Z" fill="#024383" stroke="#024383" strokeWidth="0.842105" />
    <path d="M47.5 42H56.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
    <path d="M52 46.5V37.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
    <defs>
      <clipPath id="clip0_4203_75854">
        <rect width="61.2248" height="63.4681" fill="white" transform="translate(0 0.53418) rotate(-0.500001)" />
      </clipPath>
    </defs>
  </svg>

);

export default AddFileIcon;
